module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Mac quickly scanned the houses. All were in darkness save for a glimmer of light on a deck a couple of houses back. He stumbled through the soft sand toward it, followed by Pirate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused at the foot of the wooden steps leading to the house, listening, but there were no more screams. What he did think he heard though was a sob. Muffled, but nevertheless a definite sob.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Telling Pirate to stay put, he inched his way up the steps onto the deck, which was only about ten feet deep, a usual size for the acreage-tight Colony. The house loomed in front of him, a glass-and-limestone cliff that was more modern than the millennium and more stark than the architecture of Richard Meier, famous for the design of the L.A. "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("Getty museum among other things. It was also as dark as the night outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Suddenly a lamp was turned on. Through the window he glimpsed a woman. A redhead wearing a sheer black negligee and, if he was not mistaken and even though it was at fifty paces, very little else. Now contrary to the popular belief, this was not your normal bedtime attire in Malibu and nor was midnight a usual hour to retire. Most everyone in the movie biz had an early call and were in their flannel PJs, curled up in a bed, learning the next day’s lines by nine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mac knocked on the window but the woman didn’t seem to hear. She just stared down at her feet as though there was something fascinating there. Like maybe a body, Mac thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was young, maybe twenty-three, and beautiful, with everything in the right place as revealed by the sheer bit of black chiffon and lace she wore. Plus she had the face of a naughty angel. Mac felt glad to be of help. He checked, saw that the glass doors were unlocked, and in his knight-in-shining-armor role he slid it open.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her head shot up and he flung her a reassuring smile. “Hi,” he said, “I’m Mac Reilly, your neighbor. I thought I heard a scream. Are you in some kind of trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman tossed her long red curling hair out of her tearful green eyes, lifted herself to her full statuesque height and pointed a gun at him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out,” she said in a throaty whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("Mac eyed the gun. It was a Smith & Wesson Sigma .40, and definitely not to be messed with. He paused long enough to wonder why she was not pressing the button to summon Security from the gate instead of threatening him. And then the gun went off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bullet ricocheted from the polished concrete floor near his foot, shattered a crystal vase then buried itself in the back of a nearby sofa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mac didn’t wait around for a second shot. He took off down the steps, sprinting back along the beach a couple of paces behind the cowardly dog.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oops, sorry, my mistake,” she called after him, her voice floating eerily on the breeze.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3abcbd8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312364496_epub_c02_r1.vue
// module id = 72
// module chunks = 0